module.exports = __webpack_public_path__ + "5e4ce3e4eb066e111de9e294542117ae.jpeg";